// Actions
export const ONBOARDING__INITIALIZE = 'ONBOARDING__INITIALIZE';
export const ONBOARDING__INITIALIZE_LEADS = 'ONBOARDING__INITIALIZE_LEADS';
export const ONBOARDING__LEADS_SUBMIT_CONTACTS = 'ONBOARDING__LEADS_SUBMIT_CONTACTS';
export const ONBOARDING__LEADS_SUBMIT_DETAILS = 'ONBOARDING__LEADS_SUBMIT_DETAILS';
export const ONBOARDING__LEADS_SUBMIT_PREFERRED_QUOTE_TIMES =
  'ONBOARDING__LEADS_SUBMIT_PREFERRED_QUOTE_TIMES';
export const ONBOARDING__LEADS_GET_DETAILS = 'ONBOARDING__LEADS_GET_DETAILS';
export const ONBOARDING__GOTO_NEXT = 'ONBOARDING__GOTO_NEXT';
export const ONBOARDING__UPDATE_PRICED_LTRS_SERVICE = 'ONBOARDING__UPDATE_PRICED_LTRS_SERVICE';
export const ONBOARDING__UPDATE_QUOTE = 'ONBOARDING__UPDATE_QUOTE';
export const ONBOARDING__REMOVE_SERVICE = 'ONBOARDING__REMOVE_SERVICE';
export const ONBOARDING__CANCEL_ORDER = 'ONBOARDING__CANCEL_ORDER';
export const ONBOARDING__SYNC_ORDER = 'ONBOARDING__SYNC_ORDER';
export const ONBOARDING__UPDATE_INSTANT_QUOTE = 'ONBOARDING__UPDATE_INSTANT_QUOTE';
export const ONBOARDING__ACCEPT_INSTANT_QUOTE = 'ONBOARDING__ACCEPT_INSTANT_QUOTE';
export const ONBOARDING__REJECT_INSTANT_QUOTE = 'ONBOARDING__REJECT_INSTANT_QUOTE';
// Getters
export const ONBOARDING__STEPS = 'ONBOARDING__STEPS';
export const ONBOARDING__SELECTED_SERVICE = 'ONBOARDING__SELECTED_SERVICE';
export const ONBOARDING__POST_ORDER_NEXT_SCREEN = 'ONBOARDING__POST_ORDER_NEXT_SCREEN';
// Mutations
export const ONBOARDING__RESET = 'ONBOARDING__RESET';
export const ONBOARDING__MUTATE_LOADING_STATUS = 'ONBOARDING__MUTATE_LOADING_STATUS';
export const ONBOARDING__MUTATE_STEPS = 'ONBOARDING__MUTATE_STEPS';
export const ONBOARDING__MUTATE_LEADS_DETAILS = 'ONBOARDING__MUTATE_LEADS_DETAILS';
